import { getResponsiveFactorSizeResolver } from '../../resolvers/CurryingResolvers';
export default function resolveMargin(theme, screenWidth, marginSupport) {
    var result = {};
    var sizeResolver = getResponsiveFactorSizeResolver(theme, theme.designGrid.margin, screenWidth);
    if (marginSupport.margin !== undefined) {
        result.margin = sizeResolver(marginSupport.margin);
    }
    if (marginSupport.marginTopBottom !== undefined) {
        var marginTopBottom = sizeResolver(marginSupport.marginTopBottom);
        result.marginTop = marginTopBottom;
        result.marginBottom = marginTopBottom;
    }
    if (marginSupport.marginRightLeft !== undefined) {
        var marginRightLeft = sizeResolver(marginSupport.marginRightLeft);
        result.marginRight = marginRightLeft;
        result.marginLeft = marginRightLeft;
    }
    if (marginSupport.marginTop !== undefined) {
        result.marginTop = sizeResolver(marginSupport.marginTop);
    }
    if (marginSupport.marginBottom !== undefined) {
        result.marginBottom = sizeResolver(marginSupport.marginBottom);
    }
    if (marginSupport.marginRight !== undefined) {
        result.marginRight = sizeResolver(marginSupport.marginRight);
    }
    if (marginSupport.marginLeft !== undefined) {
        result.marginLeft = sizeResolver(marginSupport.marginLeft);
    }
    return result;
}
//# sourceMappingURL=MarginResolver.js.map